import { faker } from '@faker-js/faker'

import { getServiceOffer } from './ServiceOffer'

import { ApprovalProcessRequestorView, ApprovalProcessStatus } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getApprovalProcessRequestorView = asBuilder(
  (): ApprovalProcessRequestorView => ({
    approvalProcessId: faker.number.int(),
    status: faker.helpers.enumValue(ApprovalProcessStatus),
    processStatusChangedAtUtc: '2021-01-01T00:00:00',
    processChangedReasons: faker.lorem.sentence(),
    serviceOffer: {
      id: faker.number.int(),
      title: faker.string.uuid(),
    },
    groupId: faker.string.uuid(),
    ...getServiceOffer(),
  }),
)
